'use client';

import { useEffect } from 'react';
import { useCookieConsentStatus } from '@/providers/CookieConsentProvider';
declare global {
  interface Window {
    gtag?: (command: string, ...args: unknown[]) => void;
  }
}

/**
 * Manages Google Tag Manager consent mode
 * Syncs cookie consent status with GTM to ensure GDPR compliance
 */
export default function GTMConsentMode() {
  const {
    hasAnalyticsConsent,
    hasAdvertisingConsent,
    requiresConsent
  } = useCookieConsentStatus();

  // Initialize gtag stub to prevent errors before GTM loads
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // Create gtag function stub if it doesn't exist yet
    if (!window.gtag) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).dataLayer = (window as any).dataLayer || [];
      window.gtag = function gtag(..._args: unknown[]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).dataLayer?.push(_args);
      };
    }
  }, []);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.gtag) {
      return;
    }

    // Update GTM consent mode based on user preferences
    window.gtag('consent', 'update', {
      analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied',
      ad_storage: hasAdvertisingConsent ? 'granted' : 'denied',
      ad_user_data: hasAdvertisingConsent ? 'granted' : 'denied',
      ad_personalization: hasAdvertisingConsent ? 'granted' : 'denied'
    });
  }, [hasAnalyticsConsent, hasAdvertisingConsent, requiresConsent]);
  return null;
}